// internal
import { axios, def, storage, handleError, handleResponse } from './internal';

function Logout() {
    axios
        .post('/api/logout', {})
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    storage.transience.resetState();
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {});
}

export { Logout };
